import axiosInstance from './auth';

export const getPaymentHistory = async () => {
  try {
    const response = await axiosInstance.get('/payment/history');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const requestPayment = async (amount) => {
  try {
    const response = await axiosInstance.post('/payment/request', { amount });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const profileData = async () => {
  try {
    const response = await axiosInstance.get('/profile');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getBalance = async () => {
  try {
    const response = await axiosInstance.get('/payment/balance');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getLeadersByEmail = async (email = "", page = 1, limit = 10) => {
  try {
    const params = {
      page,
      limit,
    };

    if (email && email.trim()) {
      params.email = email;
    }

    const response = await axiosInstance.get('/leaders', {
      params,
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const processLeaderWithdrawal = async (email, amount) => {
  try {
    const response = await axiosInstance.post('/leaders/withdrawals', {
      Email: email,
      Amount: amount,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};